// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/medical.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/medical/medical-expiry.js';
import g1 from '../lessons/air-law/medical/medical-validity.js';

mount([g0, g1]);
